<template>
    <div class="report__page">
        <h2>Report Details</h2>
        <ReportDetailsSelector 
            :details="customDetails"
            :is-compact="true"
        />
        <!-- FAULT LOG -->
    </div>
</template>

<script>
import ReportDetailsSelector from './ReportDetailsSelector.vue';

export default {
    components: {
        ReportDetailsSelector
    },

    data() {
        return {
            customDetails: [
                { value: 'site_name', label: 'Site' },
                { value: 'asset_id', label: 'ID' },
                { value: 'name', label: 'Name' },
                { value: 'asset_type', label: 'Type' },
                { value: 'location_reference', label: 'Location Reference' },
                { value: 'area', label: 'Area' },
                { value: 'location', label: 'Sub Area' },
                { value: 'maintenance_schedule_start_date', label: 'Maintenance Schedule Start Date' },
                { value: 'fault_id', label: 'Fault ID' },
                { value: 'fault_reporter_name', label: 'Raised by Name' },
                { value: 'fault_reporter_company', label: 'Raised by Company' },
                { value: 'fault_report_note', label: 'Notes' },
                { value: 'timestamp', label: 'Timestamp' },
                { value: 'fault_status', label: 'Fault Status' },
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.report__page {
    height: 100%;
    padding: 0.5rem;

    h2 {
        padding-left: 1rem;
        margin: 0;
    }
}
</style>